import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the Nl2LiPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'italizeBewegt',
})
export class ItalizeBewegtPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    return (value?value:'').replace(/bewegt/, '<i>bewegt</i>');
  }
}



// WEBPACK FOOTER //
// ./src/pipes/italize-bewegt/italize-bewegt.ts